module.exports = __webpack_public_path__ + "common/sidebar/img-card-list-7624337376293fb7e08703ae224be5ae.webp";